
import { reducerConstants } from "../../../constants/reducer-constant";
import { INITIAL_STATE as postInspectionDiyReducerInitialState, HANDLERS as postInspectionDiyReducerHandler } from "../../../components/shared/post-inspection-diy/reducers";
import { INITIAL_STATE as repeatUserTransitionReducerInitialState, HANDLERS as repeatUserTransitionReducerHandler } from "../../../components/shared/car-animation-loader/reducers";
import { INITIAL_STATE as scriptLoaderInitialState, HANDLERS as scriptLoaderReducerHandler } from "../../../components/shared/scripts-loader/reducers";
import { INITIAL_STATE as leadDataReducerInitialState, HANDLERS as leadDataReducerHandler } from "../../../components/desktop/lead-form/reducers";

export default {
    [reducerConstants.POST_INSPECTION_DIY]: { state: postInspectionDiyReducerInitialState, handler: postInspectionDiyReducerHandler },
    [reducerConstants.REPEAT_USER_TRANSITION]: { state: repeatUserTransitionReducerInitialState, handler: repeatUserTransitionReducerHandler },
    [reducerConstants.SCRIPT_LOADER]: {state: scriptLoaderInitialState, handler: scriptLoaderReducerHandler},
    [reducerConstants.LEAD_DATA]: { state: leadDataReducerInitialState, handler: leadDataReducerHandler }
};

